import { forwardRef, memo } from 'react';
import { FormattedMessage } from 'react-intl';
// Material UI imports
import type { TypographyVariant } from '@mui/material/styles';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
// SCSS imports
import { header } from './BuilderHeader.module.scss';

const titleTypographyProps = {
  variant: 'subtitle1' as TypographyVariant,
  color: 'inherit'
};

type BuilderHeaderProps = {
  readonly progress: number;
};

const BuilderHeader = forwardRef<HTMLElement, BuilderHeaderProps>(({
  progress
}, ref) => (
  <CardHeader
      ref={ref}
      titleTypographyProps={titleTypographyProps}
      title={<FormattedMessage id="builder.title"/>}
      action={(
        <Typography variant="subtitle1">
          <FormattedMessage id="builder.progress" values={{ progress: progress / 100 }}/>
        </Typography>
      )}
      className={header}
  />
));

BuilderHeader.displayName = 'BuilderHeader';

export default memo(BuilderHeader);
